<template>
  <div id="lay_content_allZh">
    <lay-top></lay-top>
    <div class="lay_content_allZh">
      <router-view></router-view>
    </div>
    <transition  name="slide-down">
      <bg-music v-if="showBgmusic"></bg-music>
    </transition>
    <lay-bottom></lay-bottom>
  </div>
</template>
<script>
export default {
  computed:{
    // 背景音乐显示
    showBgmusic() {
      return this.$store.getters.showBgmusic
    },
  },
  data(){
    return{
      keepAlive:[]
    }
  },
  methods:{

  },
  created() {
  }
}
</script>
<style lang="less">
#lay_content_allZh {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .lay_content_allZh {
    height: calc(100% - 172px);
    width: 100%;
  }
}
</style>
